import type { Routes } from '@angular/router';
import { fairGuard, platformGuard } from './core/fair/fair.guard';

/**
 * Endereços públicos fixos vêm antes do endereço da feira — nenhuma feira pode
 * se chamar `feiras`, `entrar`, `organizadores`, `privacidade`, `termos` ou
 * `cookies`.
 *
 * As telas da feira mantêm os nomes de antes (`map`, `agenda`, `exhibitors`):
 * `/:feira/map?booth=A-13` está impresso nos QR Codes colados nos estandes.
 */
export const routes: Routes = [
	{ path: '', pathMatch: 'full', redirectTo: 'feiras' },
	{
		path: 'feiras',
		canActivate: [platformGuard],
		loadChildren: () => import('./features/fairs/fairs.routes').then((m) => m.FAIRS_ROUTES),
	},
	{
		path: 'entrar',
		canActivate: [platformGuard],
		loadChildren: () => import('./features/account/account.routes').then((m) => m.ACCOUNT_ROUTES),
	},
	{
		path: 'organizadores',
		canActivate: [platformGuard],
		loadChildren: () => import('./features/organizers/organizers.routes').then((m) => m.ORGANIZERS_ROUTES),
	},
	{
		path: '',
		canActivate: [platformGuard],
		loadChildren: () => import('./features/legal/legal.routes').then((m) => m.LEGAL_ROUTES),
	},
	{
		path: 'feira-nao-encontrada',
		canActivate: [platformGuard],
		loadComponent: () => import('./features/not-found/not-found-page').then((m) => m.NotFoundPage),
	},
	{
		path: ':fairSlug',
		canActivate: [fairGuard],
		loadComponent: () => import('./layout/visitor-shell/visitor-shell').then((m) => m.VisitorShell),
		children: [
			{
				path: '',
				pathMatch: 'full',
				loadChildren: () => import('./features/home/home.routes').then((m) => m.HOME_ROUTES),
			},
			{ path: 'home', redirectTo: '' },
			{
				path: 'notices',
				loadChildren: () => import('./features/notices/notices.routes').then((m) => m.NOTICES_ROUTES),
			},
			{
				path: 'settings',
				loadChildren: () => import('./features/settings/settings.routes').then((m) => m.SETTINGS_ROUTES),
			},
			{ path: 'search', loadChildren: () => import('./features/search/search.routes').then((m) => m.SEARCH_ROUTES) },
			{ path: 'map', loadChildren: () => import('./features/map/map.routes').then((m) => m.MAP_ROUTES) },
			{ path: 'agenda', loadChildren: () => import('./features/agenda/agenda.routes').then((m) => m.AGENDA_ROUTES) },
			{
				path: 'exhibitors',
				loadChildren: () => import('./features/exhibitors/exhibitors.routes').then((m) => m.EXHIBITORS_ROUTES),
			},
		],
	},
	{ path: '**', redirectTo: 'feira-nao-encontrada' },
];
